import { RecoveryEmployeeDTO } from "../dto/RecoveryUserDTO";
import { firstValueFrom } from "rxjs";
import { EmployeeAccessLevel } from "../../organization/dto/Employee";
import { EmployeeService } from "../../organization/service/employee.service";
import {
  AdminPDFAccess,
  AdminPortalRole,
  DataRoomAccess, ICON_FOR_USER_ROLE, MarketAnalysisAccess,
} from "../../organization/components/shared/team-modal-crud/team-modal-crud.component";
import {
  EmployeeCheckBoxByTable,
  EmployeeCheckboxFields,
  EmployeeRole,
} from "../../organization/components/shared/team-table/team-table.component";

export const hasAdminPortalAccess = (value: AdminPortalRole): boolean => value === 'Admin';
export const hasAdminPDFAccess = (value: AdminPDFAccess): boolean => value === 'Admin';
export const hasMarketAnalysisAccess = (value: MarketAnalysisAccess): boolean => value === 'Viewer';
export const hasDataRoomAccess = (value: DataRoomAccess): boolean => value === 'Admin';

const ADMIN_ROLE: EmployeeRole = { role: 'Admin', displayRole: 'Admin', iconNameAndStylingLeft: ICON_FOR_USER_ROLE.Admin };
const VIEWER_ROLE: EmployeeRole = { role: 'Viewer', displayRole: 'Viewer', iconNameAndStylingLeft: ICON_FOR_USER_ROLE.Viewer };
const NO_ACCESS_ROLE: EmployeeRole = { role: 'No Access', displayRole: '-', iconNameAndStylingLeft: ICON_FOR_USER_ROLE['No Access'] };

export const CURRENT_ROLES = {
  Admin: ADMIN_ROLE,
  Viewer: VIEWER_ROLE,
  'No Access': NO_ACCESS_ROLE,
};

export class RecoveryUserEmployeeWrapper {
  private employeeService: EmployeeService;

  readonly currentRoles = CURRENT_ROLES;
  readonly currentEmployeeRoles = CURRENT_ROLES;
  employeeRoles: EmployeeRole[] = [CURRENT_ROLES.Admin, CURRENT_ROLES.Viewer, CURRENT_ROLES['No Access']];
  adminOrNoAccessRoles: EmployeeRole[] = [CURRENT_ROLES.Admin, CURRENT_ROLES['No Access']];
  viewerOrNoAccessRoles: EmployeeRole[] = [CURRENT_ROLES.Viewer, CURRENT_ROLES['No Access']];
  employeeCheckboxFields = new EmployeeCheckboxFields();

  constructor(employeeService: EmployeeService) {
    this.employeeService = employeeService;
  }

  async updateAccessLevel(role: EmployeeAccessLevel, employee: RecoveryEmployeeDTO): Promise<void> {
    if (employee.accessLevel === role) {
      return;
    }
    await this.employeeService.updateAccessLevel(employee.id, role);
    employee.accessLevel = role;
  }

  async updateCheckBoxInDB(employee: RecoveryEmployeeDTO, field: EmployeeCheckBoxByTable, value: boolean): Promise<void> {
    if (field === 'org-admin') {
      await firstValueFrom(this.employeeService.updateRecoveryOrgAdmin(employee.id, value));
    } else {
      await this.employeeService.updateCheckBox(employee.id, field, value);
    }
    // After successful update.
    switch (field) {
      case 'org-admin':
        employee.organizationAdmin = value;
        if (value) {
          employee.accessLevel = 'Admin';
          employee.kpiAccessLevel = 'Admin';
          employee.portalPdf = value;
          employee.marketAnalysis = value;
          employee.portalAdminAccess = value;
          employee.kpis = value;
        }
        break;
      case 'portfolio-notifications':
        employee.portfolioNotification = value;
        break;
      case 'admin-portal':
        employee.portalAdminAccess = value;
        break;
      case 'portal-pdf':
        employee.portalPdf = value;
        break;
      case 'market-analysis':
        employee.marketAnalysis = value;
        break;
      case 'kpi-notification':
        employee.kpis = value;
        break;
    }
  }
}
